import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, MessageCircleHeartIcon } from 'lucide-react';
const testimonials = [{
  name: 'Martín',
  image: 'https://cdn.magicpatterns.com/uploads/p6wgsBo96GTfKdMsmfJBo4/ChatGPT_Image_23_jul_2026,_02_06_59_p.m..png'
}, {
  name: 'Sofía',
  image: 'https://cdn.magicpatterns.com/uploads/kt6ZCVW535mhW1Cy2xYkxX/ChatGPT_Image_23_jul_2026,_02_07_01_p.m..png'
}, {
  name: 'Diego',
  image: 'https://cdn.magicpatterns.com/uploads/9ph6u12k9unTcFK6HBsrsY/ChatGPT_Image_23_jul_2026,_02_07_04_p.m..png'
}];
export function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const showTestimonial = (nextIndex: number) => {
    setDirection(nextIndex > activeIndex ? 1 : -1);
    setActiveIndex((nextIndex + testimonials.length) % testimonials.length);
  };
  const goPrevious = () => showTestimonial(activeIndex - 1);
  const goNext = () => showTestimonial(activeIndex + 1);
  return <section className="py-16 sm:py-24 px-4 bg-padel-dark border-y border-padel-muted overflow-hidden" aria-labelledby="testimonials-heading" data-id="element-430" data-mp="h4n4idrci3bz">
      <div className="max-w-5xl mx-auto" data-id="element-431" data-mp="78abzj7jdvit">
        <div className="text-center max-w-2xl mx-auto mb-10 sm:mb-12" data-id="element-432" data-mp="79bpduc0yu3p">
          <div className="inline-flex items-center gap-2 text-padel-lime font-bold text-sm uppercase tracking-[0.16em] mb-4" data-id="element-433" data-mp="c625ghntxpp4">
            <MessageCircleHeartIcon className="w-5 h-5" data-id="element-434" data-mp="zwy1jqzbj726" />
            Mensajes reales
          </div>
          <h2 id="testimonials-heading" className="text-3xl sm:text-5xl font-display font-black text-white uppercase tracking-tight" data-id="element-435" data-mp="14uzhi31g6q9f">
            Lo que dicen quienes ya lo están usando
          </h2>
        </div>

        <div className="relative max-w-md mx-auto" data-id="element-436" data-mp="v3mqterdy64z">
          <div className="absolute inset-x-10 top-8 bottom-8 bg-padel-lime/10 blur-3xl rounded-full pointer-events-none" data-id="element-437" data-mp="1iv223x153xsd" />

          <div className="relative overflow-hidden rounded-[1.75rem] border border-padel-muted bg-padel-surface shadow-[0_24px_60px_rgba(0,0,0,0.45)]" data-id="element-438" data-mp="1nnlckl4j6csy">
            <AnimatePresence initial={false} mode="wait" data-id="element-439" data-mp="1sj5x3n93x54i">
              <motion.figure key={testimonials[activeIndex].name} initial={{
              opacity: 0,
              x: direction * 56
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: direction * -56
            }} transition={{
              duration: 0.28,
              ease: 'easeOut'
            }} drag="x" dragConstraints={{
              left: 0,
              right: 0
            }} dragElastic={0.12} onDragEnd={(_, info) => {
              if (info.offset.x < -70) goNext();
              if (info.offset.x > 70) goPrevious();
            }} className="cursor-grab active:cursor-grabbing" data-id="element-440" data-mp="1sjpbitzjtbds">
                <img src={testimonials[activeIndex].image} alt={`Conversación de WhatsApp con ${testimonials[activeIndex].name} sobre Método Pro-Pádel 360`} className="block w-full h-auto select-none" draggable={false} data-id="element-441" data-mp="vs3ujc0c7o1s" />
              </motion.figure>
            </AnimatePresence>
          </div>

          <div className="flex items-center justify-center gap-4 mt-6" data-id="element-442" data-mp="37efl3myev382">
            <button type="button" onClick={goPrevious} aria-label="Ver testimonio anterior" className="w-11 h-11 rounded-full border border-padel-muted bg-padel-surface text-white hover:border-padel-lime hover:text-padel-lime transition-colors flex items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-padel-lime focus-visible:ring-offset-2 focus-visible:ring-offset-padel-dark" data-id="element-443" data-mp="3cetqex8mnz2e">
              <ChevronLeftIcon className="w-5 h-5" data-id="element-444" data-mp="2spjfrxnqo4b5" />
            </button>

            <div className="flex items-center gap-2" role="tablist" aria-label="Testimonios" data-id="element-445" data-mp="2xi2uwz22r7i2">
              {testimonials.map((testimonial, index) => <button key={testimonial.name} type="button" role="tab" aria-selected={index === activeIndex} aria-label={`Ver testimonio de ${testimonial.name}`} onClick={() => showTestimonial(index)} className={`h-2.5 rounded-full transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-padel-lime focus-visible:ring-offset-2 focus-visible:ring-offset-padel-dark ${index === activeIndex ? 'w-7 bg-padel-lime' : 'w-2.5 bg-padel-muted hover:bg-gray-400'}`} data-id="element-446" data-mp="20zofj5yceu7p" data-mpi={index} />)}
            </div>

            <button type="button" onClick={goNext} aria-label="Ver siguiente testimonio" className="w-11 h-11 rounded-full border border-padel-muted bg-padel-surface text-white hover:border-padel-lime hover:text-padel-lime transition-colors flex items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-padel-lime focus-visible:ring-offset-2 focus-visible:ring-offset-padel-dark" data-id="element-447" data-mp="1qtwv4ajlg1bq">
              <ChevronRightIcon className="w-5 h-5" data-id="element-448" data-mp="k7jhbqymjv60" />
            </button>
          </div>

          <p className="text-center text-xs text-gray-500 mt-4" data-id="element-449" data-mp="k9e3f8lmttbo">
            Deslizá para ver más mensajes.
          </p>
        </div>
      </div>
    </section>;
}